module.exports = __webpack_public_path__ + "img/front_page_policies.3ba2da6e.svg";